import { useQueryClient } from '@tanstack/react-query'

import {
  getGetDeliveryPreferenceQueryKey,
  type PreferenceUpdate,
  usePutDeliveryPreference,
} from '@dhl/receiver-preference-api'
import { dataLayerPublish } from '@dhl/datalayer'

export const useSubmitPreference = (): {
  submitPreference: (addressId: string, body: PreferenceUpdate) => Promise<void>
} => {
  const { mutateAsync: updatePreference } = usePutDeliveryPreference()
  const queryClient = useQueryClient()

  const submitPreference = async (addressId: string, body: PreferenceUpdate): Promise<void> => {
    try {
      await updatePreference({
        addressId,
        data: {
          preference: body,
        },
      })

      await queryClient.invalidateQueries({
        queryKey: getGetDeliveryPreferenceQueryKey(),
      })

      await queryClient.invalidateQueries({
        queryKey: getGetDeliveryPreferenceQueryKey(addressId),
      })
    } catch (error) {
      dataLayerPublish('ERROR', { error, page: 'preference-submit' })
      throw error
    }
  }

  return { submitPreference }
}
